import { acceptNumberValue } from '../../field-viewer/shared-normalizers';
export const quizNumberInputViewer = {
    normalizeLoadedValue: acceptNumberValue
};

//# sourceMappingURL=definition-viewer.js.map